import React, { useEffect, useState } from "react";
import { getContacts, deleteContact } from "../services/firestoreService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import PageHead from "../components/common/PageHead";

const ContactsPage = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const contactData = await getContacts();
        setContacts(contactData);
      } catch (err) {
        setError("Failed to load contacts.");
      } finally {
        setLoading(false);
      }
    };
    fetchContacts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;
    try {
      await deleteContact(id);
      setContacts((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      setError("Failed to delete contact.");
    }
  };

  if (loading) return <p className="text-center mt-4">Loading contacts...</p>;
  if (error) return <p className="text-center mt-4 text-red-500">{error}</p>;

  return (
    <>
      <PageHead name="Contact Submissions" />
      <div className="container mx-auto p-6 max-w-screen-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
            <thead className="bg-gray-200 text-gray-700 text-lg">
              <tr>
                <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Name</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Email</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Subject</th>
                <th className="border border-gray-600 px-4 py-2 w-2/6">Message</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Date</th>
                <th className="border border-gray-600 px-4 py-2 w-1/12">Action</th>
              </tr>
            </thead>

            <tbody>
              {contacts.length > 0 ? (
                contacts.map((contact, index) => (
                  <tr key={contact.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
                    <td className="h-20 px-4 border border-gray-600 text-center">{index + 1}</td>
                    <td className="h-20 px-4 border border-gray-600">{contact.name}</td>
                    <td className="h-20 px-4 border border-gray-600">{contact.email}</td>
                    <td className="h-20 px-4 border border-gray-600">{contact.subject}</td>
                    <td className="h-20 px-4 border border-gray-600 break-words max-w-xs">{contact.message}</td>
                    <td className="h-20 px-4 border border-gray-600">
                      {new Date(contact.timestamp?.seconds * 1000).toLocaleDateString()}
                    </td>
                    <td className="h-20 px-4 border border-gray-600 text-center">
                      <button
                        onClick={() => handleDelete(contact.id)}
                        className="p-2 rounded text-red-500 hover:bg-red-500 hover:text-white"
                        title="Delete Contact"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">No contact submissions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ContactsPage;
